var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 2H8a1 1 0 0 0-1 1v2H6V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.84 17.386.63-.771-4.323-3.623H12v-1H3.15l4.32-3.606-.63-.771L1 12.491z"
})));
export default SvgLogout;